import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon, useTheme } from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
function Rocket(props) {
  const { viewBox = "0 0 48 48", size, sx: inputSx, ...rest } = props;
  const theme = useTheme();
  const sx = typeof size === "number" ? { fontSize: size, ...inputSx } : inputSx;
  return /* @__PURE__ */ jsxs(SvgIcon, { ...rest, sx, viewBox, "data-tidal": "TidalIllustration", "data-tidal-illustration": "Rocket", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: theme.vars.palette.primary.dark,
        d: "M22 39a10.6 10.6 0 0 0-5.36-.447A11.49 11.49 0 0 0 15 39a10.474 10.474 0 0 0-6 6v-8.69c0-1.34.336-2.657.978-3.832a10.2 10.2 0 0 1 1.362-1.818A24.983 24.983 0 0 1 14 28l8 11Zm4 0a10.6 10.6 0 0 1 5.36-.447A11.49 11.49 0 0 1 33 39a10.474 10.474 0 0 1 6 6v-8.69a7.99 7.99 0 0 0-.978-3.832 10.2 10.2 0 0 0-1.362-1.818A24.983 24.983 0 0 0 34 28l-8 11Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: theme.vars.palette.secondary.dark,
        d: "m24 3-1.619.883A18 18 0 0 0 13 19.685v4.63a18 18 0 0 0 9.381 15.8L24 41l1.619-.883A18 18 0 0 0 35 24.315v-4.63a18 18 0 0 0-9.381-15.8L24 3Z"
      }
    ),
    /* @__PURE__ */ jsx("path", { fill: theme.vars.palette.primary.dark, d: "M24 24a6 6 0 1 0 0-12 6 6 0 0 0 0 12Z" }),
    /* @__PURE__ */ jsx("path", { fill: theme.vars.palette.secondary.main, d: "M24 22a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: theme.vars.palette.primary.dark,
        d: "m24 46-.155-.311A7.995 7.995 0 0 1 23 42.111V29a1 1 0 0 1 2 0v13.111c0 1.242-.29 2.467-.846 3.578L24 46Zm7.48-37H16.52a17.99 17.99 0 0 1 5.86-5.12L24 3l1.62.88A17.99 17.99 0 0 1 31.48 9Z"
      }
    )
  ] });
}
Rocket.tidalIllustrationMeta = {
  categories: ["illustration"],
  name: "Rocket"
};
validateTidalLicense();
export {
  Rocket
};
//# sourceMappingURL=Rocket.js.map
